import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/projectmng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/projectmng/costcalc/CostCalcLockList';
import { useDispatch } from 'react-redux';
import { listProjectCosts } from '../../../modules/projectModule/projectCosts';

const OrderProductListContainer = () => {
  const dispatch = useDispatch();
  const { project, costs } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    costs: projectModule.projectCosts.costs,
  }));

  useEffect(() => {
    dispatch(listProjectCosts(project.prjUuid));
  }, [project]);

  return (
    <Box>
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          py: 1,
        }}
      >
        <CostSummary project={project} />
      </Box>
      <Box
        sx={{
          py: 1,
        }}
      >
        {costs && <CostCalcLockList costs={costs} />}
      </Box>
    </Box>
  );
};

export default OrderProductListContainer;
